var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.country)?_c('div',{class:`vti__flag ${_vm.iso2CountryCode}`,attrs:{"title":_vm.countryName}}):_c('div',[_vm._v(_vm._s(_vm.countryCode))])
}
var staticRenderFns = []

export { render, staticRenderFns }